import React, { Component } from 'react';
import Slider from 'react-rangeslider';
require(`../assets/${process.env.PAGE}/css/custom-slider.css`);

class CustomSlider extends Component {

    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            value: null
        };
    }

    onChange(value) {
        let selectedValue = this.props.productList[value - 1];
        this.props.input.onChange(Number(selectedValue));
        this.setState({ value: Number(value) });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialValue && nextProps.productList){
            let currentValue = nextProps.productList.indexOf(nextProps.initialValue.toString());
            this.setState({ value: Number(currentValue + 1) });
        }
    }

    render() {

        return ( this.props.productList &&
            <div className={'form-group'}>
                <label className="control-label">{this.props.label}</label>
                <Slider {...this.props.input}
                    orientation='horizontal'
                    min={1}
                    max={this.props.productList.length}
                    step={1}
                    onChange={this.onChange}
                    value={this.state.value}
                />
            </div>
        );
    }
}

export default CustomSlider;



/** WEBPACK FOOTER **
 ** ./src/components/CustomSlider.js
 **/